import { atom } from 'jotai';
import cuid from 'cuid';

const listLoadReviewAtom = atom<string>(cuid());
const createReviewAtom = atom<boolean>(false);
const editReviewAtom = atom<{
  show: boolean;
  comment_id: string;
  target_title: string;
}>({
  show: false,
  comment_id: '',
  target_title: '',
});

export { listLoadReviewAtom, createReviewAtom, editReviewAtom };
